export type Breadcrumb = {
  name: string
  href?: string
}

const HOME_BREADCRUMB: Breadcrumb = {
  name: 'Startseite',
  href: '/',
}

export const TEACHER_LOCATION_BREADCRUMB: Breadcrumb = {
  name: 'Fahrschulen',
  href: '/fahrschulen/',
}

const COURSE_LOCATION_BREADCRUMBS: Record<string, Breadcrumb> = {
  firstaid: { name: 'Nothelferkurse', href: '/nothelferkurs/' },
  vku: { name: 'Verkehrskundekurse', href: '/vku/' },
  pgs: { name: 'Motorradgrundkurse', href: '/motorrad-grundkurs/' },
  wab: { name: 'WAB Kurse', href: '/wab-kurse/' },
}

export function getCourseLocationBreadcrumb(
  courseTypeGroup: string
): Breadcrumb | undefined {
  return COURSE_LOCATION_BREADCRUMBS[courseTypeGroup]
}

export function getLocationBreadcrumb(location: {
  name: string
  slug: string
}): Breadcrumb {
  return {
    name: `Fahrschule ${location.name}`,
    href: `/fahrschule-${location.slug}/`,
  }
}

export function buildBreadcrumbs(
  currentName: string,
  ...parents: (Breadcrumb | undefined)[]
): Breadcrumb[] {
  return [
    HOME_BREADCRUMB,
    ...parents.filter((parent) => parent !== undefined),
    { name: currentName },
  ]
}
